module.exports = __webpack_public_path__ + "static/img/velocity.d24e4bf0.png";